// main.ts
import { C8Node } from "csi/typings";
import Cache from "csi/store/Cache";
import { browserStore } from "csi/state/rootStore";

export function addToFileUploadMap(docMaster: C8Node, cache: Cache): void {
	if (docMaster?.CurrentRevision) {
		const currentRevision = cache.getNode(docMaster.CurrentRevision);
		const fileCNL = currentRevision?.["File"];
		const fileNode = cache.get(fileCNL);
		const fileSize = fileNode?.FileSize || 0;
		browserStore.addToFileUploadMap(docMaster.CurrentRevision, "File", fileSize, new AbortController());
	}
}